import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { csvRow } from '../csv';

dayjs.extend(utc);

// A client-side CSV of the filtered rows (spec 2026-09-21 §5.2). Stripe's
// own export carries the arrival date in UTC; so does this one. No server
// endpoint for the payouts list — the escaping, the formula guard and the
// download itself live in ../csv.js, shared with the payout detail's export.
const STATUS_LABEL = {
  paid: 'Paid', pending: 'Pending', in_transit: 'In transit', failed: 'Failed', canceled: 'Canceled',
};
// The table's word for the row, Returned included (a failed payout the bank
// sent back after depositing it): the export says what the screen says.
const statusLabel = (row) =>
  (row.returned && row.status === 'failed' ? 'Returned' : STATUS_LABEL[row.status] || row.status || '');

const to = (row) =>
  row.destinationBankName
    ? `${row.destinationBankName}${row.destinationLast4 ? ` ****${row.destinationLast4}` : ''}`
    : '';

export const payoutsCsv = (rows) => {
  const lines = rows.map((row) =>
    csvRow([
      statusLabel(row),
      row.method || '',
      to(row),
      row.createdAt ? dayjs(row.createdAt).format('YYYY-MM-DD') : '',
      row.arrivalDate ? dayjs.utc(row.arrivalDate).format('YYYY-MM-DD') : '',
      typeof row.amount === 'number' ? row.amount.toFixed(2) : '',
      row.stripePayoutId || '',
    ]),
  );
  // "Arrive by", like the table's own column (owner, 2026-09-23).
  return ['Status,Method,To,Sent,Arrive by,Amount,Payout ID', ...lines].join('\n');
};

export const csvFilename = ({ from, to: until }) =>
  `payouts-${dayjs.utc(from).format('YYYY-MM-DD')}-${dayjs.utc(until).format('YYYY-MM-DD')}.csv`;
